export default __webpack_public_path__ + "static/media/immutable-x.285c49cf.constants";